<template>
  <div class="certification-container">
    <div class="certification-title">
    <h1>À PROPOS DE SUPRACARE</h1>
    <div class="breadcrumb">
      <a href="/">Accueil</a> > <a href="/certification">Qui sommes-Nous</a>
    </div>
  </div>
    <div class="supracare-description">
      <link href="https://fonts.googleapis.com/css2?family=Merriweather:wght@300;400;700&family=Open+Sans:wght@300;400;600&display=swap" rel="stylesheet">

      <h2>Notre objectif</h2>
      <p>
        L’objectif de Supracare est de fournir les solutions de laboratoire les plus fiables et de haute qualité,
        grâce à des investissements continus dans la recherche, le développement et l'innovation.
      </p>

      <h2>Notre entreprise</h2>
      <p>
        Supracare est un fournisseur leader de produits de laboratoire et de santé, y compris des consommables, des produits chimiques,
        des réactifs et des compléments alimentaires. Nous nous engageons à offrir des solutions fiables pour les laboratoires, les cliniques,
        et les instituts de recherche à travers le Maroc, avec une attention particulière à la qualité et à la satisfaction client.
      </p>

      <h2>Notre certification</h2>
      <p>
        Notre certification ISO pour la fabrication et la distribution de produits de laboratoire garantit que les normes de qualité les plus élevées
        sont maintenues dans tous nos processus.
      </p>

      <h2>Notre engagement</h2>
      <p>
        Supracare s’engage à être à la pointe de l'industrie, en réinvestissant une partie significative de ses revenus dans l'innovation,
        pour offrir des produits toujours plus performants.
      </p>

      <h2>Notre succès</h2>
      <p>
        Depuis de nombreuses années, Supracare fournit des produits qui non seulement répondent mais dépassent les attentes du marché,
        grâce à une qualité supérieure, des prix compétitifs, et un service client exceptionnel.
      </p>
    </div>
  </div>
</template>


<script>
import { onMounted } from 'vue';

onMounted(() => console.log("Mounted"));

export default {
  name: 'CertificationI',
};
</script>

<style scoped>
.certification-container {
 padding: 0px 0px;
  background-color: #f9f9f9; /* Couleur de fond claire pour l'ensemble de la section */
  text-align: justify;
  z-index: 1;
  overflow: hidden;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; /* Police professionnelle */
}

.certification-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5); /* Couche de fond plus douce */
  z-index: -1;
}


.certification-title {
  position: relative;
  background-image: url('C:/Users/PC MAROC/supracare_web/src/assets/img6.jpg');
  background-size: cover;
  background-position: center;
  color: rgb(29, 22, 77); /* Texte blanc pour un meilleur contraste */
  padding: 150px 300px;
  font-size: 14px;
  margin: 0 auto;
  text-align: center;
  border-radius: 2px; /* Bordures légèrement arrondies */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Ombre subtile pour donner de la profondeur */
  max-width: 1000px; 
  z-index: 1;
}

.breadcrumb {
  font-size: 12px;
  color: #555;
  margin-top: 20px;
}

.breadcrumb a {
  color: #0c0c0c;
  text-decoration: none;
  font-weight: bold;
}

.breadcrumb a:hover {
  text-decoration: underline;
}

/* Styles pour la description */
.supracare-description {
  padding: 20px 200px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1); /* Ombre douce pour un effet professionnel */
  border-radius: 2px;
  margin-top: 0px;
  font-family: 'Open Sans', sans-serif; /* Police moderne et lisible */
}

.supracare-description h2 {
  color: #4c4a4d; /* Couleur professionnelle */
  font-size: 1.8rem;
  margin-bottom: 15px;
  font-family: 'Merriweather', serif;
}

.supracare-description p {
  font-size: 1.1rem;
  line-height: 1.75;
  color: #333;
  margin-bottom: 20px;
  font-family: 'Open Sans', sans-serif;
}

/* Ajout de styles responsives pour mobile */
@media (max-width: 768px) {
  .certification-title {
    font-size: 2rem;
  }

  .supracare-description {
    padding: 20px;
  }

  .supracare-description h2 {
    font-size: 1.5rem;
  }

  .supracare-description p {
    font-size: 1rem;
  }
}


/* Responsive pour les petits écrans */
@media (max-width: 768px) {
  .certification-title {
    font-size: clamp(1.5rem, 5vw, 1rem);
    padding: 100px 0px;
  }

  .breadcrumb {
    font-size: 0.9rem;
  }

  .supracare-description {
    padding: 20px;
  }

  .supracare-description h2 {
    font-size: 1.5rem;
  }

  .supracare-description p {
    font-size: 1rem;
  }
}


</style>
